

















































































































import MainButton from '@/main-components/common/MainButton.vue';
import { axios } from '@/utils/axios';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import { Component, Vue } from 'vue-property-decorator';
declare const MediaRecorder: any;

export async function checkText(
  blob: Blob,
  text: string,
  hertz: number,
): Promise<any> {
  let results: any = null;

  try {
    const fd = new FormData();
    fd.append('file', blob, 'sss');

    const headers = {
      'Content-Type': 'multipart/form-data',
      text,
      hertz: `${hertz}`,
    };

    const { data } = await axios.post('/users/transcribe-audio', fd, {
      headers,
    });
    results = data;
  } catch (error) {
    console.log('error:', error);
    return false;
  }

  return results;
}

@Component({
  components: { MainButton, BeatLoader },
})
export default class AudioTest extends Vue {
  mediaRecorder: any = null;
  audioSource: any = null;
  isRecording = false;
  istranscribing = false;
  results = [];
  text =
    'Position the cursor in document where you want to generate random text';
  isTextEditable = false;
  sampleRateHertz = 48000;

  mounted() {
    const audioIN = { audio: true };

    navigator.mediaDevices
      .getUserMedia(audioIN)
      .then(mediaStreamObj => {
        this.mediaRecorder = new MediaRecorder(mediaStreamObj);

        let dataArray: any[] = [];

        this.mediaRecorder.ondataavailable = function(ev: any) {
          dataArray.push(ev.data);
        };

        // Convert the audio data in to blob
        this.mediaRecorder.onstop = async () => {
          // blob of type mp3
          const audioData = new Blob(dataArray, { type: 'audio/mp3;' });

          // Creating audio url with reference
          const audioSrc = window.URL.createObjectURL(audioData);
          this.audioSource = audioSrc;

          // NOTE: Make the audio limit to 0.5 MB
          if (audioData.size && audioData.size > 500000) {
            this.$toasted.global.mainToast({
              message: 'Error: Audio too long',
            });
            this.results = [];
          } else {
            this.getFrequency(audioData);
            const response = await checkText(
              audioData,
              this.text,
              this.sampleRateHertz,
            );

            if (!response) {
              this.$toasted.global.mainToast({
                message: 'Did you read the text? Please read again.',
              });
              this.results = [];
            } else {
              this.results = response.results;
            }
          }

          this.istranscribing = false;

          dataArray = [];
        };
      })

      // If any error occurs then handles the error
      .catch(function(err) {
        console.log(err.name, err.message);
      });
  }

  startRecording() {
    if (this.isRecording || this.istranscribing || this.isTextEditable) return;
    this.results = [];
    this.isRecording = true;
    this.mediaRecorder.start();
  }

  stopRecording() {
    if (!this.isRecording || this.istranscribing || this.isTextEditable) return;
    this.isRecording = false;
    this.istranscribing = true;

    // NOTE: To cater issue if user click stop too fast
    setTimeout(() => {
      this.mediaRecorder.stop();
    }, 1500);
  }

  toggleEditText() {
    this.isTextEditable = !this.isTextEditable;
  }

  getFrequency(blob: Blob) {
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.result && typeof reader.result !== 'string') {
        // Decode the audio data using the Web Audio API
        const audioContext = new AudioContext();
        audioContext.decodeAudioData(reader.result, buffer => {
          // Get the sample rate from the audio buffer
          const sampleRateHertz = buffer.sampleRate;
          console.log('sampleRateHertz:', sampleRateHertz);

          if (sampleRateHertz) {
            this.sampleRateHertz = sampleRateHertz;
          }
        });
      }
    };

    reader.readAsArrayBuffer(blob);
  }
}
